import React from "react";
import styled from "@emotion/styled";
import Sal from "images/main_lineup/Sal.png";
import Danang from "images/main_lineup/Danang.png";
import DaLopez from "images/main_lineup/Da Lopez.png";
import Kunto from "images/main_lineup/Kunto.png";
import Exhibitors from "images/exhibitors.png";

const Container = styled.div`
  margin-top: 90px;

  h2 {
    font-family: unset;
    text-transform: capitalize;
    text-align: center;
  }
  p {
    font-size: 32px;
    line-height: 120%;
    text-align: center;
  }

  @media (max-width: 600px) {
    h2 {
      font-size: 28px;
    }
    p {
      font-size: 18px;
    }
  }
`;

const Lineup = styled.div`
  @media (max-width: 600px) {
    p {
      max-width: 240px;
      margin: 0 auto;
    }
  }
`;

const Flex = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: center;
  margin: 40px -18px;

  img {
    width: 290px;
    margin: -20px 18px 20px;
  }
  p {
    max-width: 240px;
    margin: 0 auto;
  }
  @media (max-width: 690px) {
    img {
      width: 240px;
    }
  }
  @media (max-width: 600px) {
    margin: 40px 0;
    justify-content: space-between;

    img {
      width: 47%;
      margin-left: 0;
      margin-right: 0;
    }
  }
`;

const Exhibitor = styled.div`
  > div {
    margin: 64px auto;
  }
  img {
    width: 100%;
  }
`;

export default function MainLineupExhibit() {
  return (
    <Container>
      <Lineup>
        <h2>Our Lineup</h2>
        <p>Witness all of the acts of Main Event COMPFEST</p>
        <Flex>
          <img src={Sal} id="sal" />
          <img src={Danang} id="danang" />
          <img src={DaLopez} id="dalopez" />
          <img src={Kunto} id="kunto" />
        </Flex>
      </Lineup>
      <Exhibitor>
        <h2>Our Exhibitors</h2>
        <p>
          Get immersed by our various exhibitors and their engaging activities.
        </p>
        <div>
          <img src={Exhibitors} />
        </div>
      </Exhibitor>
    </Container>
  );
}
